import { createSlice } from "@reduxjs/toolkit";

const initialItemTypeState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    itemtypeForEdit: undefined,
    lastError: null,
    message: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const itemtypeSlice = createSlice({
    name: "itemtypes",
    initialState: initialItemTypeState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            state.message = null;

            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.message = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        // getItemTypeById
        itemtypeFetched: (state, action) => {
            state.actionsLoading = false;
            state.itemtypeForEdit = action.payload.itemtypeForEdit;
            state.floorPlans = action.payload.itemtypeForEdit.floorPlans;
            state.error = null;

        },
        // getItemTypeChart
        itemtypeChartFetched: (state, action) => {

            state.actionsLoading = false;
            state.itemtypeChart = action.payload.itemtypeChart;
            state.error = null;

        },
        // getItemTypeChart
        itemtypeHourlyChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.itemtypeChartHour = action.payload.itemtypeChartHour;
            state.error = null;

        },
        // getItemTypeChart
        itemtypeHourlyZoneChartFetched: (state, action) => {
            state.actionsLoading = false;
            state.itemtypeChartHourZone = action.payload.itemtypeChartHourZone;
            state.error = null;

        },
        // get list data
        itemtypesFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
            state.itemtypeForEdit = undefined;
            state.floorPlans = undefined;
            state.itemtypeChart = undefined;
            state.itemtypeChartHour = undefined;
            state.itemtypeChartHourZone = undefined;
        },
        // createItemType
        itemtypeCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        // updateItemType
        itemtypeUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.message = action.payload.msgResponse;
        },
        // itemtypeDeleted
        itemtypeDeleted: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
            state.actionsLoading = false;
        },
        setMessage: (state, action) => {
            state.error = null;
            state.message = action.payload.msgResponse;
        },
        floorPlanDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.filter(item => item.id !== action.payload.id);
        },
        floorPlanUpdated: (state, action) => {
            const { id, floorPlan } = action.payload;
            state.error = null;
            state.actionsLoading = false;
            state.floorPlans = state.floorPlans.map((data) => {

                if (data.id === id) {
                    return floorPlan;
                }

                return data;
            });
        }

    }
});
